import { computed, type ComputedRef } from 'vue'
import type { AnalyticsData } from '@/tracking/analytics/analyticsTracker'

/** Analytics context is set once at setup; computed values keep each key reading the current prop. */
export const liveEventData = (getEventData: () => AnalyticsData): Record<string, ComputedRef<unknown>> =>
  Object.fromEntries(Object.keys(getEventData()).map((key) => [key, computed(() => getEventData()[key])]))
